import { Box, Loader } from '@hopskipdrive/react-components';

import { useLoaderStore } from '../../stores/loaderStore';
import { PageHeading } from '../PageHeading';

import { StyledBackdrop } from './PageLoader.styles';

export const PageLoader: React.FC = () => {
  const { loading, message } = useLoaderStore();

  return (
    <StyledBackdrop open={loading} transitionDuration={{ appear: 500, enter: 200, exit: 500 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
        <PageHeading textColor="primary" variant="h1">
          {message}
        </PageHeading>
        <Loader />
      </Box>
    </StyledBackdrop>
  );
};
